import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .stripe-card-container {
    padding: 15px 10px;
    border: solid 1px ${ ({ theme }) => theme.colors.grey };
    border-radius: 4px;
  }

  .modal-content {
    padding: 8px 0;
  }

  .buttons-container {
    display: flex;
    justify-content: center;
  }

  .dataform-container {
    display: flex;
    flex-direction: column;
    margin: 16px 0;

    .dataform-horizontal {
      display: flex;
      flex-direction: row;
      gap: 16px;
      position: relative;

      .icon-container {
        position: absolute;
        right: 0;
        top: 4px;
        width: 24px;
        height: 24px;
      }
    }
  }

  .checkbox-wrapper {
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin: 16px 0 0;

    .checkbox-container {
      width: 24px;
      height: 24px;
      background-color: ${ ({ theme }) => theme.colors.white };
      border-radius: 5px;
      cursor: pointer;
      &.selected {
        background-color: ${ ({ theme }) => theme.colors.primary };
      }
    }
  
    .link {
      cursor: pointer;
    }
  }
`
